import { render, staticRenderFns } from "./PercentileMetricScale.vue?vue&type=template&id=32d1d39f"
import script from "./PercentileMetricScale.vue?vue&type=script&lang=js"
export * from "./PercentileMetricScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports